<template>
    <v-data-table
        dense
        :headers="headers"
        :items="data"
        :data="loading"
        :loading="loading"
        :server-items-length="length"
        :options="options"
        @update:options="updateOptions"
        :footer-props="footer"
        disable-sort
        >
        <template v-slot:[`item.code`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.purchase_requisition.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.code}}
        </template>
        <template v-slot:[`item.orders_count`]="{item}">
            <div v-if="item.orders_count" class="font-weight-bold">
                <v-icon v-for="c in item.orders_count" :key="c" :color="item.orders_count > 0 ? 'success' : 'primary' ">mdi-cart</v-icon>
            </div>
            <div v-else>
                <v-icon color="grey lighten-2">mdi-cart</v-icon>
            </div>
        </template>
        <template v-slot:[`item.priority`]="{item}">
            {{formatPriority(item.priority).name}}
        </template>
        <template v-slot:[`item.state`]="{item}">
            <PStatus :state="item.state"/>
        </template>
    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex'
import PStatus from './../common/PStatus.vue';

export default {
    name: "PurchaseRequisitionList",
    components: {
        PStatus
    },
    data() {
        return {
            footer: {
                'items-per-page-options': [5, 10, 25]
            },
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Created By", value: "created_by" },
                { text: "Priority", value: "priority" },
                { text: "Orders", value: "orders_count" },
                { text: "State", value: "state" }
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            options: "purchase/requisition/options",
            loading: "purchase/requisition/loading",
            length: "purchase/requisition/length",
            data: "purchase/requisition/list",
            priorities: "purchase/priority/list",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "purchase/requisition/updateOptions"
        }),
        formatPriority(priority) {
            return this.priorities.find(each => each.id == priority);
        },
        handleClickRow(item) {
            this.$router.push({name: "PurchaseRequisitionDisplay", params: {id: item.id}})
        }
    }
}
</script>

<style>

</style>